<div class="page-wrapper" *ngIf="!selectedComm">
    <div class="overview-container">
        <div class="overview-wrapper">
            <div *ngFor="let commIF of commIFArray; index as i">
                <app-comms-list-status-indicator
                    [isReceivingData]="isReceivingData"
                    [index]="i"
                    [commIF]="commIF"
                    (onSelectCommIf)="handleSelectedCommsIF($event)"
                ></app-comms-list-status-indicator>
            </div>
        </div>
    </div>
</div>

<div class="selected-comm-wrapper" *ngIf="selectedComm">
    <app-comms-status-indicator
        [isReceivingData]="isReceivingData"
        [index]="commIFArray.indexOf(selectedComm)"
        [selectedComm]="selectedComm"
        (onGoBack)="handleSelectedCommsIF(null)"
    ></app-comms-status-indicator>
</div>
